const BCTToken = {
  "_format": "hh-sol-artifact-1",
  "contractName": "BCTToken",
  "sourceName": "contracts/core/BCTToken.sol",
  "abi": [
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "treasurySafe",
          "type": "address"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "inputs": [],
      "name": "INVALID",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "MAX_SUPPLY",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        }
      ],
      "name": "allowance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "burn",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "burnFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "subtractedValue",
          "type": "uint256"
        }
      ],
      "name": "decreaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "addedValue",
          "type": "uint256"
        }
      ],
      "name": "increaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transfer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
};

export default BCTToken;
